var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4762_2901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.662 24.1679C21.163 24.8377 21.8023 25.392 22.5363 25.793C23.2704 26.1941 24.0821 26.4326 24.9164 26.4923C25.7508 26.5521 26.5882 26.4317 27.3719 26.1393C28.1556 25.847 28.8673 25.3895 29.4587 24.7979L32.9587 21.2979C34.0213 20.1977 34.6092 18.7242 34.5959 17.1948C34.5827 15.6653 33.9692 14.2022 32.8876 13.1207C31.8061 12.0391 30.343 11.4256 28.8135 11.4123C27.284 11.399 25.8105 11.987 24.7103 13.0496L22.7037 15.0446M25.3287 21.8346C24.8277 21.1648 24.1884 20.6105 23.4544 20.2095C22.7203 19.8084 21.9086 19.57 21.0743 19.5102C20.2399 19.4505 19.4025 19.5708 18.6188 19.8632C17.8351 20.1555 17.1234 20.613 16.532 21.2046L13.032 24.7046C11.9694 25.8048 11.3815 27.2783 11.3948 28.8078C11.408 30.3373 12.0215 31.8003 13.1031 32.8819C14.1846 33.9634 15.6477 34.5769 17.1772 34.5902C18.7067 34.6035 20.1802 34.0155 21.2803 32.9529L23.2753 30.9579",
    stroke: "#243677",
    strokeWidth: 4.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9878,
    cy: 22.9878,
    r: 22.0164,
    stroke: "#243677",
    strokeWidth: 1.94263
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4762_2901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.87b512ef6d5980deb9728fab7d6b7449.svg";
export { ForwardRef as ReactComponent };